import type { SearchPage } from '@bulknutrients/bulk-shared-lib/interfaces/InformationPage';
import { TrimText as textTrim } from '@bulknutrients/bulk-shared-lib/utils';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import type { ReactElement } from 'react';

export function SearchResultCardPage({
  hit,
}: {
  hit: SearchPage;
}): ReactElement {
  return (
    <div className="flex flex-col gap-1 border-0 border-b border-solid border-grey-light px-0 py-2.5">
      <TextLink
        href={hit.slug}
        data-umami-event-location="Search Result Card Page"
      >
        <span className="text-lg">{hit.title}</span>
      </TextLink>
      <span>{textTrim(hit.description, 248)}</span>
    </div>
  );
}
